import { REVIEW_CLIP_NAME_WORDS } from 'modules/match-video/domain/constants/review-clip-kinds';
import { ReviewClipKind } from 'modules/match-video/domain/interfaces';

export interface ParsedClipName {
  kind: ReviewClipKind;
  /** `HH:MM:SS`, zero-padded so that string comparison is time order. */
  capturedAt?: string;
}

const KIND_BY_WORD = new Map<string, ReviewClipKind>(
  (Object.entries(REVIEW_CLIP_NAME_WORDS) as [ReviewClipKind, readonly string[]][]).flatMap(([kind, words]) =>
    words.map((word) => [word, kind] as const),
  ),
);

// `Goal 21-14-19.mp4`, `Опасный момент 21-14-19`, `danger_9.05.33`, `GOAL21-14-19` — words, then H-M-S with `-`,
// `_`, `.` or `:` between.
const CLIP_NAME = /^(.*?)(\d{1,2})[-_.:](\d{2})[-_.:](\d{2})(?!\d)/;

const pad = (value: number) => String(value).padStart(2, '0');

/** `  Опасный_Момент - ` → `опасный момент`: case, underscores, dashes and repeated spaces do not matter. */
const normalizeWords = (text: string) =>
  text
    .toLocaleLowerCase()
    .replace(/[\s_.-]+/g, ' ')
    .trim();

/** Reads the clip kind and the camera time from a file name; an unknown name → `other` without a time. */
export function parseClipName(fileName: string): ParsedClipName {
  const baseName = fileName.replace(/\.[^./\\]+$/, '');
  const match = CLIP_NAME.exec(baseName);
  if (!match) {
    return { kind: 'other' };
  }

  const [, prefix, hours, minutes, seconds] = match;
  const kind = KIND_BY_WORD.get(normalizeWords(prefix)) ?? 'other';
  const h = Number(hours);
  const m = Number(minutes);
  const s = Number(seconds);
  if (h > 23 || m > 59 || s > 59) {
    return { kind };
  }

  return { kind, capturedAt: `${pad(h)}:${pad(m)}:${pad(s)}` };
}
